import React from 'react'
import { Link } from 'react-router-dom'

const DevotionalWeeklyCard = ({item}) => {







  return (
   
   
    <div  className='col-12 col-sm-6'>
      
              <Link
                to={item.url ? item.url.substring(item.url.indexOf('/devotional')+11) : '/'}
                className="dna-article-card"  
               >
             <div className="dna-card-thumb">
            <img
              src={item.img ? item.img : '/devotional/assets/images/error_img.webp'}
              alt={item.title ? item.title : "Title"}
              loading="lazy"
              onError={(e) => {
                e.currentTarget.src = '/devotional/assets/images/error_img.webp';
              }}
            />
              </div>
                <div className="dna-card-body">
                <h2 className="dna-card-title">{item.title ? item.title : ""}</h2>
                {/* {article.short_desc && (
                  <p className="dna-card-desc" dangerouslySetInnerHTML={{__html : article.short_desc ? he.decode(article.short_desc) : ''}} />
                )} */}
             </div>
        </Link>


   </div>
  )
}

export default DevotionalWeeklyCard;
